import styled  from 'styled-components';

export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 360px;
  width: 100%;
  padding: var(--spacing-layout-base03);

  @media (max-width: 992px) {
    max-width: 992px;
  }
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: var(--spacing-inner-base03) 0;
`;

export const FormLabel = styled.label`
  color: var(--color-text-secondary);
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
`;

export const TextField = styled.input`
  box-sizing: border-box;
  border: 1px solid var(--color-separator-default);
  border-radius: var(--border-radius-xs);
  color: var(--color-text-primary);
  font-size: 1rem;
  padding: var(--spacing-inner-base02) var(--spacing-inner-base03);
  width: 100%;
`;

export const Button = styled.button`
  background: #e26126;
  border: none;
  border-radius: var(--border-radius-pill);
  color: var(--color-text-inverted);
  cursor: pointer;
  font-size: 1em;
  font-weight: bold;
  padding: var(--spacing-inner-base04) var(--spacing-inner-base03);
  margin-top: 2rem;

  &:disabled {
    cursor: not-allowed;
    background: var(--color-interaction-disabled);
    &:hover {
      background: var(--color-interaction-disabled);
    }
  }

  &:hover {
    transition: all 100ms ease-in-out;
    background: #c9562b;
  }
`;

export const Preview = styled.div`
  background: #c4c4c4;
  flex: 1;
  padding: var(--spacing-layout-base03);
`;

export const Flex = styled.div `
  display: flex;
  align-items: center;
  gap: 1.5rem;
`
export const Title = styled.h1`
  color: #1a1d39;
  font-size: 1.5rem;
`;
export const IconButton  = styled.span`
  color: #1a1d39;
  `;
  
export const ContainerColors = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin-top: var(--spacing-layout-base);
  gap: var(--spacing-inner-base03);
`;

export const FormInfo = styled.span`
  color: var(--color-text-secondary);
  font-size: 0.9rem;
  margin-top: var(--spacing-inner-base);
  word-break: break-all;
`;

export const Fill = styled.span`
  flex: 1 0 0;
`;
